import { ICmsLink } from '@components/typescript';
import { PUBLIC_HOST } from '@config/index';

const prepareURLByCMSLink = (link: ICmsLink | string, emptyLink = '#'): string => {
  let url = emptyLink;
  const linkValue = typeof link === 'string' ? link : link?.path;
  if (linkValue && linkValue.length) {
    if (linkValue.substring(0, 1) === '/') {
      url = `${PUBLIC_HOST}${linkValue}`;
    } else if (linkValue.substring(0, 4) === 'http') {
      url = linkValue;
    } else {
      url = `${PUBLIC_HOST}/${linkValue}`;
    }
  }
  return url;
};

export default prepareURLByCMSLink;
